import { Link } from 'react-router-dom';
import { t, getLocale, setLocale } from '../i18n';

export default function LandingPage() {
  return (
    <div style={{ minHeight: '100vh' }}>
      {/* Nav */}
      <nav className="landing-nav" style={{ padding: '0 40px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid var(--border)', background: 'white' }}>
        <span className="nav-logo" style={{ fontFamily: 'Playfair Display', fontSize: 22, fontWeight: 700, color: 'var(--match-a)' }}>{t('brand')}</span>
        <div className="nav-links" style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button
            className="btn btn-ghost"
            style={{ fontSize: 14 }}
            onClick={() => setLocale(getLocale() === 'en' ? 'ja' : 'en')}
          >
            {getLocale() === 'en' ? '日本語' : 'EN'}
          </button>
          <Link to="/login" className="btn btn-ghost">{t('signIn')}</Link>
          <Link to="/request-access" className="btn btn-primary">{t('requestAccess')}</Link>
        </div>
      </nav>

      {/* Hero */}
      <section className="landing-hero" style={{
        background: 'linear-gradient(160deg, #3d5429 0%, #5a7a3a 50%, #8aab5e 100%)',
        color: 'white', padding: '100px 40px', textAlign: 'center'
      }}>
        <div style={{ fontSize: 64, marginBottom: 20 }}>🍵</div>
        <h1 style={{ fontSize: 52, lineHeight: 1.15, marginBottom: 20, maxWidth: 640, margin: '0 auto 20px' }}>
          {t('heroTitle')}
        </h1>
        <p style={{ fontSize: 20, opacity: 0.85, maxWidth: 480, margin: '0 auto 40px', lineHeight: 1.6 }}
          dangerouslySetInnerHTML={{ __html: t('heroSubtitle') }}
        />
        <Link to="/request-access" className="btn btn-primary" style={{
          fontSize: 17, padding: '14px 36px',
          background: 'white', color: 'var(--match-a)', fontWeight: 700,
          boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
        }}>
          {t('requestAccess')}
        </Link>
      </section>

      {/* How it works */}
      <section className="landing-how-it-works" style={{ padding: '80px 40px', maxWidth: 900, margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', fontSize: 34, marginBottom: 48 }}>{t('howItWorks')}</h2>
        <div className="landing-steps-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 24 }}>
          {[
            { n: '1', icon: '🏢', title: t('step1Title'), desc: t('step1Desc') },
            { n: '2', icon: '🗣', title: t('step2Title'), desc: t('step2Desc') },
            { n: '3', icon: '🗓', title: t('step3Title'), desc: t('step3Desc') },
            { n: '4', icon: '✨', title: t('step4Title'), desc: t('step4Desc') },
          ].map(step => (
            <div key={step.n} className="card" style={{ padding: 24, textAlign: 'center' }}>
              <div style={{ fontSize: 36, marginBottom: 12 }}>{step.icon}</div>
              <h3 style={{ fontSize: 18, marginBottom: 8, fontFamily: 'DM Sans', fontWeight: 600 }}>{step.title}</h3>
              <p style={{ color: 'var(--text-muted)', fontSize: 14, lineHeight: 1.6 }}>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="landing-cta" style={{ background: 'var(--green-50)', padding: '60px 40px', textAlign: 'center', borderTop: '1px solid var(--border)' }}>
        <h2 style={{ fontSize: 30, marginBottom: 12 }}>{t('readyForNext')}</h2>
        <p style={{ color: 'var(--text-muted)', marginBottom: 28 }}
          dangerouslySetInnerHTML={{ __html: t('joinToday') }}
        />
        <Link to="/request-access" className="btn btn-primary" style={{ fontSize: 16, padding: '12px 32px' }}>
          {t('requestAccess')}
        </Link>
      </section>
    </div>
  );
}
